import { render, staticRenderFns } from "./StandartsListSubItem.vue?vue&type=template&id=0cab6748&"
import script from "./StandartsListSubItem.vue?vue&type=script&lang=js&"
export * from "./StandartsListSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports